import http from "./http.config";

export const fetchSurveyTemplates = (params = {}) =>
  http.get("/providers/survey-templates", { params }).then((res) => res.data);

export const fetchSurveySavedTemplates = (params = {}) =>
  http
    .get("/providers/survey-saved-templates", { params })
    .then((res) => res.data);

export const saveSurveyTemplate = (payload: Record<string, unknown>) =>
  http.post("/providers/save-survey-template", payload).then((res) => res.data);
